// extracted by mini-css-extract-plugin
module.exports = {"dragDropDivNotDragging":"DragAndDrop_dragDropDivNotDragging__3jbb0","dragDropDivOnDrag":"DragAndDrop_dragDropDivOnDrag__2RC61"};